var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62 62",
    style: {
      enableBackground: "new 0 0 62 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st10{fill:#FFB780;}\r\n\t.st11{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1190"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_45-3",
    className: "st10",
    cx: 31,
    cy: 31,
    r: 31
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M42.4,20.8c-0.4-0.4-0.8-0.5-1.3-0.5H31H20.9c-0.5,0-0.9,0.2-1.3,0.5c-0.4,0.4-0.5,0.8-0.5,1.2v15.5 c0,0.5,0.2,0.9,0.5,1.3c0.4,0.4,0.8,0.5,1.3,0.5h5.7v2.4H31h4.5v-2.4h5.7c0.5,0,0.9-0.2,1.3-0.5c0.4-0.4,0.5-0.8,0.5-1.3V22.1 C42.9,21.6,42.7,21.2,42.4,20.8z M41.1,35v1.9v0.6H31H20.9v-0.6V35V22.1H31h10.1V35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M30,28.5c-0.3,0-0.5,0.2-0.5,0.5v5.5c0,0.3,0.2,0.5,0.5,0.5h2c0.3,0,0.5-0.2,0.5-0.5V29c0-0.3-0.2-0.5-0.5-0.5 H30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M24.4,31.2c-0.3,0-0.5,0.2-0.5,0.5v2.7c0,0.3,0.2,0.5,0.5,0.5h2c0.3,0,0.5-0.2,0.5-0.5v-2.7 c0-0.3-0.2-0.5-0.5-0.5H24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M35.1,25.7v8.8c0,0.3,0.2,0.5,0.5,0.5h2c0.3,0,0.5-0.2,0.5-0.5v-8.8c0-0.3-0.2-0.5-0.5-0.5h-2 C35.3,25.2,35.1,25.4,35.1,25.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/Tool.3e8633f95dbeaf17862947793e7e02ef.svg";
export { ForwardRef as ReactComponent };